// @flow

import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import ContactForm from '../ContactForm';

import './AbizolTable.scss';

export default class Footer extends Component {
  render() {
    return (
      <section className="evomer-description">
        <div className="evomer-usage_container container row">
          <div className="col-12">
            <img src="/img/abizol-logo.svg" className="abizol-logo-grey"/>
              <div className="h3-red bold-header">
                Ablizol w 2k - zużycie
              </div>
              <div className="table-row">
                  <img src="/img/abizol.png" className="abizol-photo-table"/>
                <table className="properties-table">
                  <tr>
                    <td className="bold-text">Typ izolacji</td>
                    <td className="bold-text">Liczba warstw</td> 
                    <td className="bold-text">Końcowa grubość powłoki [mm]</td>
                    <td className="bold-text">Orientacyjne zużycie [kg]</td>
                  </tr>
                  <tr>
                    <td className="bold-text">Lekka - wilgoć gruntowa</td>
                    <td>2</td> 
                    <td>3</td>
                    <td>4,5</td>
                  </tr>
                  <tr>
                    <td className="bold-text">Średnia - woda nienapierająca</td>
                    <td>2</td> 
                    <td>3</td>
                    <td>4,5</td>
                  </tr>
                  <tr>
                    <td className="bold-text">Ciężka - napierająca woda gruntowa</td>
                    <td>2 z wkładką</td> 
                    <td>5</td>
                    <td>5,5</td>
                  </tr>
                  <tr>
                    <td className="bold-text">Klejenie płyt</td>
                    <td>-</td> 
                    <td>-</td>
                    <td>1 - 2</td>
                  </tr>
                </table>
              </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AbizolTable/AbizolTable.js